import React from 'react';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import Input from 'components/form/Input';
import ChipInput from 'components/form/ChipInput';
import CheckboxGroup from 'components/form/CheckboxGroup';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import useSnack  from 'hooks/useSnack';
import {useMutation} from "@apollo/react-hooks";
import {UPDATE_PROFILE} from "graphql/lc/profile";
import extend from "lodash/extend";

const FormItem = Form.FormItem;

const HighSchoolForm = ({ college_info, user, form: { getFieldDecorator, validateFields } }) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_PROFILE);

  const onSubmit = () => {
    return validateFields().then((values) => {
      return update({
        variables: {
          id: user.id,
          input: {
            college_info: extend(college_info, values)
          },
        },
      }).then(
        () => {
          snack.success('Profile saved');
        },
        (e) => {
          snack.error(e.message);
        },
      );
    });
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container spacing={4}>
          <Grid item md={8}>
            <Typography className={classes.header} variant="h5">
              College Info
            </Typography>
            <Form>
              <FormItem>
                {getFieldDecorator('colleges_attended', {
                  initialValue: college_info?.colleges_attended
                })(
                  <Input
                    fullWidth
                    label="Which college do you attend?"
                    placeholder="Enter college name"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('graduation_year', {
                  initialValue: college_info?.graduation_year
                })(
                  <Input
                    fullWidth
                    placeholder="Enter graduation year"
                    label="Expected Graduation Year"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('majors', {
                  initialValue: college_info?.majors
                })(
                  <Input
                    label="Current major(s)?"
                    placeholder="Enter major(s)"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('minors', {
                  initialValue: college_info?.minors
                })(
                  <Input
                    label="Current minor(s)?"
                    placeholder="Enter minor(s)"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('involvements', {
                  initialValue: college_info?.involvements
                })(
                  <Input
                    label="What are you involved in?"
                    hint="Extracurriculars, hobbies, achievements, jobs"
                    placeholder="Enter  what are you involved"
                  />,
                )}
              </FormItem>
            </Form>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent className={classes.footer}>
        <Button variant="contained" color="primary" onClick={onSubmit}>
          Save
        </Button>
      </CardContent>
    </Card>
  );
};

export default Form.create()(HighSchoolForm);
